import { AxiosResponse } from 'axios';
import { getHttp } from 'SharedDir/backend/axios/http';
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { SedDelo } from 'SharedDir/declarations/sed-delo';

const SED_DELO_URL = `${SERVER_API}/sed-delo`;

export default class SedDeloApiClass extends SimpleApi<never, never, never, SedDelo.UserBare> {
  constructor() {
    super(`${SED_DELO_URL}/users`);
  }

  // eslint-disable-next-line class-methods-use-this
  async getSettings() {
    const { data } = (await getHttp().get(
      `${SED_DELO_URL}/settings`
    )) as AxiosResponse<SedDelo.Settings>;
    return data;
  }

  // eslint-disable-next-line class-methods-use-this
  async saveSettings(body: Pick<SedDelo.Settings, 'signingUserId'>) {
    const { data } = (await getHttp().put(
      `${SED_DELO_URL}/settings`,
      body
    )) as AxiosResponse<SedDelo.Settings>;
    return data;
  }
}
